import { Button } from "antd";

export const GenericBankFeedsButton = ({
  text,
  onClick,
  disabled,
}: {
  text: string;
  onClick: () => void;
  disabled: boolean;
}) => {
  return (
    <div className="flex flex-column justify-center">
      <Button
        className={` 
        flex 
        justify-center 
        items-center 
        py-4 sm:py-5 
        mt-2
        mb-[32px]
        rounded-md 
        text-white
        font-medium
        bg-[#212430] 
        hover:bg-[#020211] hover:text-[#fff] hover:border-[#020211]
      `}
        style={{ width: 400 }}
        block
        disabled={disabled}
        onClick={onClick}>
        {text}
      </Button>
    </div>
  );
};
